import { render, staticRenderFns } from "./BaseInfo.vue?vue&type=template&id=7ca9b0df&"
import script from "./BaseInfo.vue?vue&type=script&lang=js&"
export * from "./BaseInfo.vue?vue&type=script&lang=js&"
import style0 from "./BaseInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/workspace/yx-web-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ca9b0df')) {
      api.createRecord('7ca9b0df', component.options)
    } else {
      api.reload('7ca9b0df', component.options)
    }
    module.hot.accept("./BaseInfo.vue?vue&type=template&id=7ca9b0df&", function () {
      api.rerender('7ca9b0df', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Activity/Children/BaseInfo.vue"
export default component.exports